/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any */

import {
  InferProviderDeps,
  Provider,
  ProviderId,
  ProviderValue,
} from '../provider/types';
import { checkCircularDependency, getInnerProviders } from './helpers';
import { Module } from './types';

/* @__NO_SIDE_EFFECTS__ */
export const createModule = <EntryProvider extends Provider>(
  entryProvider: EntryProvider
): Module<EntryProvider> => {
  type Deps = InferProviderDeps<EntryProvider>;
  checkCircularDependency(entryProvider, new Set());

  const resolveDependency = (
    deps: Deps,
    provider: Provider,
    valuesMap: Map<ProviderId, ProviderValue>
  ) => {
    if (valuesMap.has(provider.id)) {
      return valuesMap.get(provider.id);
    }

    const innerDeps = Object.entries(getInnerProviders(provider)).reduce(
      (acc, [key, innerDep]) => {
        return {
          ...acc,
          [key]: resolveDependency(deps, innerDep, valuesMap),
        };
      },
      {}
    );

    const result = provider.factory({
      deps,
      innerDeps,
    });

    valuesMap.set(provider.id, result);

    return result;
  };

  return {
    /* @__NO_SIDE_EFFECTS__ */
    init(deps) {
      return resolveDependency(deps, entryProvider, new Map()) as any;
    },
  };
};
